export * from '@platform/version/public-api';
